module.exports = "/resources/assets/prod/5ff3064d338a52cb30f0c80c33309500.svg";